// React
import { Link, useHistory } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

// Reactstrap
import { Col, Row } from 'reactstrap';

// components
import { ModalInputUnits } from './ModalUnits/index';
import { CardList } from '../../components/card_list';
import { FloatButton } from '../../components/floatButton';
import { PageWrapper } from '../../components/pageWrapper';

// Redux
import { useSelector, useDispatch } from 'react-redux';
import {
  Units as unitsDispatch,
  CreateUnits,
  DeleteUnits,
  UpdateUnits,
  Organizations,
} from '../../store/actions';

const Units = () => {
  const [isHover, setIsHover] = useState(0);
  const [selectUnit, setSelectUnit] = useState('');

  const [modal_animationLeft, setmodal_animationLeft] = useState(false);
  function tog_animationLeft() {
    setSelectUnit('');
    setmodal_animationLeft(!modal_animationLeft);
  }

  const dispatch = useDispatch();
  const history = useHistory();

  const { units, success, organizations } = useSelector((state) => ({
    error: state.Units.error,
    units: state.Units.units,
    organizations: state.Organizations.organizations,
    success: state.Units.success,
  }));

  const handleSubmit = (e) => {
    if (selectUnit === '') {
      dispatch(
        CreateUnits({
          organization_id: e.value,
          name: e.name,
        })
      );
      tog_animationLeft();
      // Atualizar unidade
    } else {
      dispatch(
        UpdateUnits({
          id: selectUnit.id,
          data: {
            organization_id: e.value,
            name: e.name,
          },
        })
      );
      tog_animationLeft();
    }
  };

  const handleDelete = (values) => {
    const { id } = values;

    dispatch(DeleteUnits(id));
  };

  const handleEdit = (values) => {
    const { id, name, organization_id, organization_name } = values;

    setmodal_animationLeft(true);

    setSelectUnit({
      id: id,
      id_organization: organization_id,
      name_organization: organization_name,
      name: name,
    });
  };

  useEffect(() => {
    dispatch(unitsDispatch());
    dispatch(Organizations());
  }, [dispatch, success]);

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">Nome</span>,
      sortable: false,
      width: '30%',
      selector: (cell) => {
        return (
          <React.Fragment>
            <div className="d-flex align-items-center fw-medium ">
              <img
                src={
                  'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTvJbDQU-40aHmCeYQeH0Gx7r04CfWhmWvbAQ&usqp=CAU'
                }
                alt=""
                className="rounded-circle"
                width="30"
                height="30"
                style={{
                  marginRight: '10px',
                }}
              />
              <Link to="#" className="currency_name">
                {cell.name}
              </Link>
            </div>
          </React.Fragment>
        );
      },
    },
    {
      name: <span className="font-weight-bold fs-13 ">Organização</span>,
      selector: (row) => row.organization_name,
      sortable: true,
    },
  ];

  return (
    <PageWrapper title={'Unidades'}>
      <Row>
        <Col xs={12}>
          <CardList
            data={units ? units : []}
            title="Unidades"
            titleButton="Nova unidade"
            handleButton={tog_animationLeft}
            columns={columns}
            pagination
            persistTableHead
            perPage={10}
            onRowMouseEnter={(row) => {
              setIsHover(row.id);
            }}
            onRowMouseLeave={() => {
              setIsHover(0);
            }}
            isSearchRemote={false}
            actions={[
              {
                id: 1,
                name: 'edit',
                label: 'Editar',
                onPress: (cellProps) => handleEdit(cellProps),
                icon: 'las la-pen',
                classNameColorIcon: 'primary',
              },
            ]}
            handleDelete={(cellProps) => handleDelete(cellProps)}
          />
        </Col>
      </Row>
      <ModalInputUnits
        data={organizations || []}
        columns={columns}
        toogle={tog_animationLeft}
        title={selectUnit ? 'Editar Unidade' : 'Adicionar Unidade'}
        isOpen={modal_animationLeft}
        selectUnit={selectUnit ? selectUnit : null}
        handleSubmit={handleSubmit}
      />
      <FloatButton handleButton={tog_animationLeft} />
    </PageWrapper>
  );
};

export default Units;
